import { render } from "./FAQView.vue?vue&type=template&id=1dbb8a54&scoped=true"
import script from "./FAQView.vue?vue&type=script&lang=js"
export * from "./FAQView.vue?vue&type=script&lang=js"

import "./FAQView.vue?vue&type=style&index=0&id=1dbb8a54&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dbb8a54"]])

export default __exports__